import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useRef } from 'react'
import { BankDataFormContainer } from 'refunds/containers/BankDataFormContainer/BankDataFormContainer'
import type { BankDataInfo, RefundData } from 'refunds/types/refundData'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import style from './BankDataModal.module.scss'

interface BankDataModalProps {
	readonly refundData?: RefundData
	readonly handleOnError?: () => void
	readonly handleOnClose?: () => void
	readonly handleOnSave?: (values: BankDataInfo) => void
	readonly handleOnSubmit?: (values: BankDataInfo) => void
	readonly validateWithoutSave?: boolean
}

export function BankDataModal({
	refundData,
	handleOnError,
	handleOnClose,
	handleOnSave,
	handleOnSubmit,
	validateWithoutSave,
}: BankDataModalProps) {
	const { t } = useLabels()
	const { isSmall } = useResponsive()
	const modalRef = useRef<ModalAPI>(null)

	useEffect(() => {
		modalRef.current?.show()
	}, [modalRef.current])

	const handleSubmit = (values: BankDataInfo) => {
		modalRef.current?.close()
		handleOnSubmit?.(values)
	}

	const handleSave = (values: BankDataInfo) => {
		modalRef.current?.close()
		handleOnSave?.(values)
	}

	return (
		<Modal
			showTitle
			name='bank-data-form-modal'
			title={t('myRefunds.bankDetails.title')}
			ref={modalRef}
			onClose={handleOnClose}
			type={MODAL_TYPE.SHEET}
			data-testid='refunds.modal.bankData'
			className={style.container}
			{...(!isSmall && { subtitle: t('myRefunds.bankDetails.subtitle') })}
		>
			<BankDataFormContainer
				refundData={refundData}
				handleOnError={handleOnError}
				handleOnSave={handleSave}
				handleOnSubmit={handleSubmit}
				validateWithoutSave={validateWithoutSave}
			/>
		</Modal>
	)
}
